import React, { useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_NODE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const LawyerView = () => {
  const [uniqueId, setUniqueId] = useState("");
  const [email, setEmail] = useState("");

  const [pdfUrl, setPdfUrl] = useState("");

  const handleAccess = async () => {
    const { data } = await axios.post(
      `${API_BASE_URL}/api/pdf/access`,
      { uniqueID: uniqueId, email: localStorage.getItem("email") },
      { responseType: "blob" }
    );
    console.log(data);
    const pdfBlob = new Blob([data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    setPdfUrl(pdfUrl);
  };

  return (
    <div className="flex h-[92vh] bg-white p-5 gap-5">
      <div className="flex-1   flex flex-col gap-5">
        <h2 className="text-3xl font-bold text-gray-700">Access PDF</h2>
        <div className="flex flex-col gap-3 max-w-sm">
          <input
            className="border-2 border-orange-300 rounded-lg px-4 py-2 text-gray-600 focus:outline-none focus:border-orange-400"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            className="border-2 border-orange-300 rounded-lg px-4 py-2 text-gray-600 focus:outline-none focus:border-orange-400"
            placeholder="Enter Unique ID"
            value={uniqueId}
            onChange={(e) => setUniqueId(e.target.value)}
          />
        </div>
        <button
          onClick={handleAccess}
          className="py-2 px-6 max-w-sm bg-gradient-to-r from-orange-300 to-orange-500 text-white rounded-lg cursor-pointer hover:from-orange-400 hover:to-orange-600 transition-all duration-200 ease-in-out"
        >
          Submit
        </button>
      </div>
      <div className="flex-1 relative rounded-2xl overflow-hidden -ml-40">
        <div className="absolute -bottom-12 -left-12 w-52 h-52 bg-gradient-to-r from-orange-300 to-orange-500 opacity-20 rounded-full"></div>
        <div className="relative bg-white rounded-2xl h-full shadow-2xl z-10 flex flex-col overflow-hidden border border-gray-200">
          <div className="bg-gradient-to-r from-orange-300 to-orange-500 p-4">
            <h3 className="text-white text-lg font-medium">Document Viewer</h3>
          </div>
          <div className="flex-1 p-4 overflow-auto">
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                className="w-full h-full border-none rounded-lg"
                title="PDF Viewer"
              />
            ) : (
              <p className="text-gray-500 text-center">
                No document accessed yet.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LawyerView;
